<template>
  <v-container fluid fill-height grid-list-md style="padding:0px 10px 5px 10px;height:100%;width:100%;background-color:white;">
    <v-layout column fill-height style="height:100%;">
      <div style="width:100%;height:40px;display:flex;align-items:center;">
        <div v-for="(item,index) in breadCrumbList" v-bind:key="item" style="display:flex;align-items:center;">
          <div class="titleBtn" v-if="index>0">></div>
          <v-btn flat class="titleBtn" v-if="item=='Subsystem View'" v-on:click="btnClick(item)">{{ selSubSys }}</v-btn>
          <v-btn flat class="titleBtn" v-else v-on:click="btnClick(item)">Overview</v-btn>
        </div>
      </div>
      <SubsystemsOverview
          v-show="screen=='Subsystems Overview'"
          class="tabItem"
          v-bind:subSysData="subSysData"
          v-bind:active="screen=='Subsystems Overview'"
      />
      <SubsystemView
          v-show="screen=='Subsystem View'"
          class="tabItem"
          @vesselSelected="onVessSelect"
          v-bind:active="screen=='Subsystem View'"
          v-bind:subSystemData="subSysData[selSubSys]"
          v-bind:selectedSystem="selSubSys"
      />
    </v-layout>
  </v-container>
</template>

<script>
import SubsystemsOverview from "./SubsystemsOverview"
import SubsystemView from "./SubsystemView"
import {store} from "../main.js"

export default {
  name: "Subsystems",
  components: {
    SubsystemsOverview,
    SubsystemView
  },
  data() {
    return {
      screen: '',
      breadCrumbList: ['Subsystems Overview'],
      selSubSys: '',
    }
  },
  computed: {
    dataLoaded: function () {
      return store.type;
    },
    subSysData: function () {
      return store.subSystemAggr;
    }
  },
  created() {
  },
  mounted() {
    this.handleGetParameters()
  },
  methods: {
    handleGetParameters: function () {
      if (
          'sys' in this.$route.params
          && !!this.$route.params['sys']
      ) {
        this.selSubSys = this.$route.params['sys'];

        if (this.breadCrumbList.indexOf('Subsystem View') < 0) {
          this.breadCrumbList.push('Subsystem View');
        }

        this.screen = 'Subsystem View';
      } else {
        this.screen = 'Subsystems Overview';
      }
    },
    onVessSelect: function (vessel) {
      window.$cookies.set('vessel', vessel);
      let vessel_url = new URL(store.config.ship_co)
      vessel_url.pathname += `vessel-view/${vessel}`
      window.open(vessel_url.toString());
    },
    btnClick: function (item) {
      if (this.breadCrumbList.includes(item)) {
        let index = this.breadCrumbList.indexOf(item);

        this.breadCrumbList = this.breadCrumbList.slice(0, index + 1);
      } else {
        this.breadCrumbList.push(item);
      }

      if (this.screen != item) {
        this.$router.push({'path': '/subsystems'})
      }
    }
  },
  watch: {
    screen: function (screen) {
      if (screen.toLowerCase().indexOf('overview') > -1) {
        this.breadCrumbList = this.breadCrumbList.slice(0, 1);
      }
    },
    "$route.params": {
      handler: function () {
        this.handleGetParameters()
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>

.tabItem {
  max-height: calc(100% - 40px)
}

</style>
